export default __webpack_public_path__ + "static/media/eventCardPic.5fab114f.png";